import { EntityActions } from '../common/base/entity'
// import {EntityComponent} from '../entity'
export class QueueAction extends EntityActions {
	constructor(options) {
		super(options)
	}

	preActionsHooks({ actionName, item, actionMeta }) {
		if (!item || Object.keys(item).length === 0) return
		if ((item && actionName == 'addNewItem') || actionName == 'editItem') {
			let payload = { ...item }
			if (actionMeta && actionMeta.name === 'deleteConfig') payload.status = 'Deleted'
			// if (!item.emailAddress) item.emailAddress = 'system@rezolve.ai'

			let removeObjectProperties = function (obj, props) {
				for (var i = 0; i < props.length; i++) {
					if (obj.hasOwnProperty(props[i])) {
						delete obj[props[i]]
					}
				}
			}
			let properties = {
				emailAddress: item.emailAddress && item.emailAddress,
				replyTo: item.replyTo && item.replyTo,
				queueLabel: item.properties && item.properties?.queueLabel || item?.queueName,
				isDraftDelete: item?.status === 'Draft' ? true : false,
				agentConfig:item.agentConfig && item.agentConfig,
				customerAgents:item.customerAgents && item.customerAgents
			}
			let lookupProps ={}
			if(payload.lookupProps && item.itemType && item.itemType !== payload.lookupProps.itemType){
				lookupProps = payload.lookupProps
			} else {
				if(!payload.lookupProps){
					payload.lookupProps = {}
				}
				payload.lookupProps.itemType= item.itemType
				payload.lookupProps.usecase= item.usecase
				payload.lookupProps.clientApp= item.clientApp
			}
			payload.properties = properties
			item = payload
			removeObjectProperties(item, ['emailAddress', 'isDraftDelete', 'replyTo', 'itemType', 'usecase', 'clientApp','agentConfig', 'customerAgents','queueLabel'])
			if(!item.groupApprovers || item.groupApprovers.length === 0 ){			
				return {
					error:{message : 'Supervisor is Required'}
				}
			}
			return item
		} else {
			return item
		}
	}

	postActionsHooks({ actionName, item, tenantId }) {
		switch (actionName) {
			case 'getAll':
				let items =
					item &&
					item.map(i => {
						i = Object.assign({}, i, i.properties)
						i.emailAddress = i.properties && i.properties.emailAddress
						i.itemType = i.lookupProps && i.lookupProps.itemType
						i.usecase = i.usecase && i.lookupProps.usecase
						i.clientApp = i.lookupProps && i.lookupProps.clientApp
						return i
					})
				return items
			case 'getOne':
				item = Object.assign({}, item, item.properties)
				item.emailAddress = item.properties && item.properties.emailAddress
				item.itemType = item.lookupProps && item.lookupProps.itemType
				item.usecase = item.lookupProps && item.lookupProps.usecase
				item.clientApp = item.lookupProps && item.lookupProps.clientApp
				return item
			default:
				return item
		}
	}
}
